import { z } from 'zod';

/** stringToJson
 * a custom zod type that expects a string. It then checks if the string is a valid JSON string,
 * and if so, automatically converts it to a JSON object. This is useful for forms that require a
 * string representation of a JSON object, while whatever output component you use requires an actual
 * JSON object.
 *
 * an example usage can be found in:
 * src/modules/demoData/contexts/EventUploaderFormProvider.tsx
 * src/modules/demoData/components/EventUploaderForm.tsx
 */
export const stringToJson = z
  .string()
  .refine((value) => {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  })
  .transform((value) => JSON.parse(value));
